import React from "react";
import { Navigate } from "react-router";

import { EditorialDetailsPageProps } from "@companion-core/shared/app/Components/DetailsPages/EditorialDetailsPage/EditorialDetailsPage.model";
import { useEditorialDetailsPage } from "@companion-core/shared/app/Components/DetailsPages/EditorialDetailsPage/hooks/editorialDetailsPage";
import { EditorialTemplate } from "@companion-core/shared/app/Components/DetailsPages/Templates/Editorial/EditorialTemplate";
import { EDITORIAL_PAGES } from "../DetailsPage.model";

import "@companion-core/web/src/Assets/Styles/scss/editorialDetailsPage.scss";

export const EditorialDetailsPage = ({ id, origin, contentType }: EditorialDetailsPageProps) => {
  const { data, isFetching, editorialType } = useEditorialDetailsPage({ id, origin });
  const PageTemplate = EDITORIAL_PAGES[editorialType ?? ""] ?? EditorialTemplate;

  if (!isFetching && data) {
    return <PageTemplate contentType={contentType} data={data} />;
  } else if (!isFetching && !data) {
    return <Navigate to="/not-found" />;
  }
};
